import type { IMultiLanguageText } from "@/data/model/Shared";

import { translateByLocationLanguage } from "@/shared/localization/language";

interface IInternalNameItem {
    name?: IMultiLanguageText;
    internalName?: string;
}

export function getName(item: IInternalNameItem, useInternalName: boolean): string {
    return useInternalName ? getArticleNameWithInternalName(item) : translateByLocationLanguage(item.name);
}

function getArticleNameWithInternalName(item: IInternalNameItem): string {
    if (item.internalName != null) {
        return item.internalName;
    }
    return translateByLocationLanguage(item.name);
}
